const REACT_APP_FIREBASE_CONFIG = process.env.REACT_APP_FIREBASE_CONFIG

export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY

export const FIREBASE_CONFIG = REACT_APP_FIREBASE_CONFIG
  ? JSON.parse(atob(REACT_APP_FIREBASE_CONFIG))
  : null